import { Component, Input, HostListener } from '@angular/core';
import { QueryService } from '../comun/services/query.service';
import { LoaderService } from '../comun/services/loader.service';
import { Paseo } from '../comun/models/paseo.model';

@Component({
  selector: 'app-paseos',
  templateUrl: './paseos.component.html',
  styleUrl: './paseos.component.css'
})
export class PaseosComponent {
  misdatos: any = {};
  paseos: any[] = [];
  mascotas: any[] = [];
  publicar: boolean = false;
  paseo: Paseo | null = null;
  test: string = '';
  loading: boolean = false;
  busqueda: string = '';
  page: number = 1;
  limit: number = 6;

  constructor(public query: QueryService, public loader: LoaderService) {
    this.loading = true;
  }

  ngOnInit() {
    this.paseos = [];
    this.mascotas = [];
    this.paseo = null;
    this.getMisDatos();
  }

  getMisDatos() {
    this.loading = true;
    this.page = 1;
    this.paseos = [];
    this.mascotas = [];
    this.paseo = null;
    this.query.query('misdatos', 'GET', { ID: 0 }).subscribe((resultado:any) => {      
      this.misdatos = resultado;
      this.getPaseos();
    });
  }

  /*getMisPaseos() {
    this.loading = true;
    this.paseos = [];
    // mis paseos
    this.query.query('paseos', 'GET', { ID: 0, pa_us_id: this.misdatos.ID, page: null, limit: null }).subscribe((resultado:any) => {      
      this.paseos = resultado.registros;
      this.getPaseos();
    });
  }*/

  getPaseos() {
    // otros paseos
    this.query.query('paseos', 'GET', { ID: 0, pa_us_id: 0, page: this.page, limit: this.limit }).subscribe((resultado:any) => {
      if (resultado.registros.length > 0) {
        this.paseos = [
          ...this.paseos,
          ...resultado.registros
        ];
        ++this.page;
      }
      this.loading = false;
    });
  }

  publicarPaseo() {
    this.paseo = null;
    this.publicar = true;
  }

  getMascotas() {
    this.mascotas = [];
    this.query.query('mascotas', 'GET', { ID: this.misdatos.ID }).subscribe((resultado:any) => {
      this.mascotas = resultado.registros;
      if (this.paseo!.mascotas.length > 0) {
        const idsSeleccionados = new Set(
          this.paseo!.mascotas.map((m : any) => m.ma_id)
        );
        this.mascotas.forEach(mascota => {
          mascota.checked = idsSeleccionados.has(mascota.ma_id);
        });
      }
    });
  }

  filtrarPaseos() {
    const termino = this.busqueda.toLowerCase();
    return this.paseos.filter(paseo => 
      paseo.pa_titulo.toLowerCase().includes(termino) ||
      paseo.pa_descripcion.toLowerCase().includes(termino) ||
      paseo.pa_ubicacion.toLowerCase().includes(termino)
    );
  }

  @HostListener('window:scroll', [])
  onScroll() {
    if (this.loading) return;
    const pos = window.innerHeight + window.scrollY;
    const max = document.body.offsetHeight;

    if (pos >= max - 150) {
      this.getPaseos();
    }
  }

}
